import React, { useRef, useState } from "react";
import styles from "./loraWan.module.css";
import AntdTab from "../../../components/AntdTab/AntdTab";
import { SearchInput } from "../../../components";
import filterImg from "../../../assets/images/filter.png";
import ModuleControl from "./ModuleControl/ModuleControl";
import TrackVehicle from "./TrackVehichle/TrackVehicle";
import { useDispatch } from "react-redux";
import { AssetsMiddleware } from "../../../Store/Middlewares/AssetsMiddleware";

const LoRaWanControl = () => {
  const [ActiveTab, setActiveTab] = useState("1");
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  const ref = useRef();
  const onSearch = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    if (ActiveTab == 1) {
      clearTimeout(ref.current);
      ref.current = setTimeout(() => {
        dispatch(AssetsMiddleware.getSingleAssets(value)).then((data) => {});
      }, 1000);
    }
  };
  const items = [
    {
      key: "1",
      label: "Module control",
      children: <ModuleControl />,
    },
    // {
    //   key: "2",
    //   label: "Track vehicle",
    //   children: <TrackVehicle />,
    // },
  ];

  return (
    <div className={styles.upperCont}>
      <div className={styles.mainCont}>
        <AntdTab
          items={items}
          ActiveTab={ActiveTab}
          setActiveTab={setActiveTab}
          rightItems={
            <SearchInput
              onChange={(e) => onSearch(e)}
              // rightIcon={<img src={filterImg} className={styles.filterIcon} />}
            />
          }
        />
      </div>
    </div>
  );
};

export default LoRaWanControl;
